/**
 * お客さま照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 会社グループ・通知方法
 */
export interface Szoa104aResCompanygroupNotificationmethodDto {
    /**
     * 内部お客さま番号：半角数字
     */
    visitNo: string;
    /**
     * 会社グループコード：半角英数混在
     */
    companygroupcode: string;
    /**
     * 通知方法コード：半角英数混在
     */
    tutiMthdiv: string;
    /**
     * 丁目番地以下漢字テキスト：全角文字
     */
    chomeanameIkaKanjitext: string;
    /**
     * 取次契約詳細コード：半角英数混在
     */
    agencycontractSyosaicode: string;
}

